import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import // USER_CONFIG,
// BATCHES_CONFIG,
// CURRENCY_OPTIONS,
'constants/api';
import { Message, Grid } from 'semantic-ui-react';

import styled from 'styled-components';
import { Text } from '@cuemath/comps';

import { get as getConfig } from 'actions/configs';
import { getAll as getPrograms } from 'actions/programs';
import {
  get as getStudentAccountInfo,
  invalidateItem as invalidateAccountDetails,
} from 'actions/student-account';
import { openModal } from 'actions/modal';

import MODAL from 'constants/modal';
import { MODAL_FORM } from 'constants/form';
import COLORS from 'constants/colors';
// import { TOGGLED_RM_ENABLED_GK_PAYLOAD } from 'utils';

import StudentProfile from './studentProfile';
import StudentSlots from './slot-list';
import StudentListForm from './student-list-form';
import StudentCourses from './studentCourses';
import PaymentHistory from './paymentHistory';
import StudentAddon from './studentAddon';
// import { stringify } from 'querystring';

const TableHeader = styled(Text)`
  background-color: ${COLORS.HAWKESBLUE};
  border: 1px solid ${COLORS.SCIENCEBLUE};
  border-bottom-color: transparent;
  text-align: center;
  width: 40%;
  padding: 6px;
  margin: 20px 10px 0 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const TableContainer = styled(Text)`
  border: 1px solid ${COLORS.SILVERCHALICE};
  margin: 0 10px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`;

const programQueryParam = {
  is_live: true,
};

class StudentForm extends PureComponent {
  static defaultProps = {
    programs: [],
    studentAccount: null,
    toggledRMGKData: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      studentProfileInfo: null,
      detailsUpdated: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { detailsUpdated } = state;
    const { studentAccount, actions } = props;
    const { studentId } = props.match.params;

    if (detailsUpdated) {
      actions.invalidateAccountDetails(studentId);
      newState.detailsUpdated = false;
    }

    const studentAccountGet = store.get(studentAccount, studentId);

    if (studentAccountGet && studentAccountGet.isLoaded && !studentAccountGet.isStale) {
      if (studentAccountGet && Object.keys(studentAccountGet.data).length) {
        newState.studentProfileInfo = studentAccountGet.data;
      } else {
        newState.errorText = 'Student with this id does not exist';
      }
    } else if (studentAccountGet && studentAccountGet.isStale) {
      actions.getStudentAccountInfo(studentId);
    }

    return newState;
  }

  componentDidMount() {
    const { studentId } = this.props.match.params;
    /**
     * Redirecting to new students view
     * TD: Have to remove the dead code.
     **/
    window?.location?.replace(`/students/${studentId}`);
    // const { actions, programs } = this.props;

    // actions.getConfig(USER_CONFIG);
    // actions.getConfig(BATCHES_CONFIG);
    // actions.getConfig(CURRENCY_OPTIONS);

    // if (!programs.length) actions.getPrograms(programQueryParam);
    // if (studentId) actions.getStudentAccountInfo(studentId);
  }

  onUpdate = () => {
    this.setState({ detailsUpdated: true });
  };

  onViewCourseLog = studentCourseId => {
    const { actions, match } = this.props;
    const { params } = match || {};
    const { studentId } = params || {};

    actions.openModal(
      'studentCourseLogModal',
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: 'fit-content',
      },
      { studentCourseId, studentId },
    );
  };

  openEditStudentCourseForm = studentCourse => {
    const { actions } = this.props;
    actions.openModal(
      'studentCourseEditModal',
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: 'fit-content',
      },
      {
        studentCourse: studentCourse.data,
      },
    );
  };

  openStudentUpgradeForm = studentCourse => {
    const { studentProfileInfo } = this.state;
    const { grade } = studentProfileInfo || {};
    const { actions } = this.props;
    actions.openModal(
      'studentUpgradeModal',
      {
        size: 'custom',
        width: `650px`,
        height: '560px',
      },
      {
        studentCourse: studentCourse.data,
        grade,
      },
    );
  };

  openStudentTrialUpgradeForm = studentCourse => {
    // const { studentProfileInfo } = this.state;
    // const { grade } = studentProfileInfo || {};
    const { actions } = this.props;
    actions.openModal(
      'studentTrialUpgradeModal',
      {
        size: 'custom',
        width: `600px`,
        height: '540px',
      },
      {
        studentCourse: studentCourse.data,
      },
    );
  };

  openTransferClassesForm = studentCourse => {
    const { studentProfileInfo } = this.state;
    const { grade } = studentProfileInfo || {};
    const { actions } = this.props;
    actions.openModal(
      'studentTransferClassesModal',
      {
        size: 'custom',
        width: `600px`,
        height: '540px',
      },
      {
        studentCourse: studentCourse.data,
        grade,
      },
    );
  };

  openStudentRevertUpgradePaymentLinkForm = studentCourse => {
    const { actions } = this.props;
    actions.openModal(
      'studentRevertUpgradePaymentLinkModal',
      {
        size: 'custom',
        width: `600px`,
        height: '540px',
      },
      {
        studentCourse: studentCourse.data,
      },
    );
  };

  onCreatePaymentLink = student => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.PAYMENT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  onCreateNewPaymentLink = student => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.NEW_PAYMENT,
      {
        size: 'custom',
        width: `720px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  onAddOfflinePayment = student => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.PAYMENT_DATA_UPLOAD_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  onManageElectives = student => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.ELECTIVE_COURSES_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  render() {
    const { programs } = this.props;
    const { errorText, studentProfileInfo } = this.state;
    const {
      payment_history: paymentHistory = [],
      id: studentId = null,
      courses: studentCourses = [],
      addons: addOns = [],
      // parent_data: parentData,
    } = studentProfileInfo || {};

    // const { ref_code: refCode } = parentData || {};

    let isReady = false;

    if (programs && studentProfileInfo) {
      isReady = true;
    }

    const paymentHistoryData = paymentHistory?.sort(
      (paymentA, paymentB) => paymentB.paid_on - paymentA.paid_on,
    );

    return (
      <Grid>
        {errorText && (
          <Message negative>
            <p>{errorText}</p>
          </Message>
        )}

        {isReady && (
          <Grid.Row>
            <Grid.Column width={4}>
              <StudentProfile {...this.state} onUpdate={this.onUpdate} />
            </Grid.Column>

            <Grid.Column width={12}>
              <React.Fragment>
                <TableHeader>Student Courses</TableHeader>

                <TableContainer>
                  <StudentCourses
                    studentId={studentId}
                    studentCourses={studentCourses}
                    onViewCourseLog={this.onViewCourseLog}
                    openEditStudentCourseForm={this.openEditStudentCourseForm}
                    openStudentUpgradeForm={this.openStudentUpgradeForm}
                    openStudentTrialUpgradeForm={this.openStudentTrialUpgradeForm}
                    openTransferClassesForm={this.openTransferClassesForm}
                    openStudentRevertUpgradePaymentLinkForm={
                      this.openStudentRevertUpgradePaymentLinkForm
                    }
                    onManageElectives={this.onManageElectives}
                  />
                </TableContainer>
              </React.Fragment>

              <React.Fragment>
                <TableHeader>Student Add-ons Details</TableHeader>
                <TableContainer>
                  <StudentAddon studentCourses={studentCourses} addOns={addOns} />
                </TableContainer>
              </React.Fragment>

              <React.Fragment>
                <TableHeader>Student Enrolled Slot Details</TableHeader>
                <TableContainer>
                  <StudentSlots {...this.state} addSlotButtons={true} />
                </TableContainer>
              </React.Fragment>

              <React.Fragment>
                <TableHeader>Student Demo Slot Details</TableHeader>
                <TableContainer>
                  <StudentListForm
                    studentId={studentId}
                    {...this.state}
                    programs={programs}
                  ></StudentListForm>
                </TableContainer>
              </React.Fragment>

              <React.Fragment>
                <TableHeader>Student Payment History</TableHeader>
                <TableContainer>
                  <PaymentHistory
                    studentId={studentId}
                    paymentHistory={paymentHistoryData}
                    onCreateNewPaymentLink={this.onCreateNewPaymentLink}
                    onCreatePaymentLink={this.onCreatePaymentLink}
                    onAddOfflinePayment={this.onAddOfflinePayment}
                  ></PaymentHistory>
                </TableContainer>
              </React.Fragment>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    );
  }
}

export default connect(
  ({ programs, studentAccount }) => ({
    programs: store.getAll(programs, programQueryParam)
      ? store.getAll(programs, programQueryParam).data
      : null,

    studentAccount,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getConfig,
        getPrograms,
        openModal,
        getStudentAccountInfo,
        invalidateAccountDetails,
      },
      dispatch,
    ),
  }),
)(StudentForm);
